import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

let sceneTextEnterJ: any = null,
    sceneTextLeaveJ: any = null;
export default function J() {
    const { useLang, useRouter, useEffect, useState, useRef, gtm, Link } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('smart_home_panel_2.launch.detail');
    const [textEnter, setTextEnter] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resizeAni = () => {
                if (sceneTextEnterJ) {
                    AniContainer.removeScene(sceneTextEnterJ);
                    sceneTextEnterJ = null;
                }
                if (sceneTextLeaveJ) {
                    AniContainer.removeScene(sceneTextLeaveJ);
                    sceneTextLeaveJ = null;
                }

                const clientH = (window.innerHeight || 0) * 0.2;
                const startH = Math.min(clientH, 150);
                sceneTextEnterJ = AniContainer.create({
                    triggerElement: '.shp2-detail-J .text-info',
                    triggerHook: 1,
                    offset: startH,
                    duration: 200,
                    onEnter: () => setTextEnter(true),
                    //onLeave: () => setTextEnter(false),
                });
            };
            resizeAni();
            // window.addEventListener('resize', resizeAni);
            return () => {
                if (sceneTextEnterJ) {
                    AniContainer.removeScene(sceneTextEnterJ);
                    sceneTextEnterJ = null;
                }
                if (sceneTextLeaveJ) {
                    AniContainer.removeScene(sceneTextLeaveJ);
                    sceneTextLeaveJ = null;
                }
                // window.removeEventListener('resize', resizeAni);
            };
        }
    }, []);

    useEffect(() => {
        if (typeof window !== 'undefined' && window?.innerWidth <= 1024) {
            const resize = () => {
                const scrollEl = document.querySelector('.shp2-detail-J .box-1 .scroll-box') as HTMLDivElement;
                const imgEl = document.querySelector('.shp2-detail-J .box-1 .scroll-box .box-img') as HTMLDivElement;
                if (scrollEl && imgEl) {
                    scrollEl.scrollLeft = (scrollEl.scrollWidth - scrollEl.clientWidth) / 2;
                }
            };
            resize();
            window.addEventListener('resize', resize);
            return () => window.removeEventListener('resize', resize);
        }
    }, []);

    return (
        <section className={`shp2-detail-J shp2-detail-section ${css['shp2-detail-J']}`}>
            <div className={`text-info ${textEnter ? 'enter' : ''}`}>
                <p className="subtitle">{t('secJ_subtitle')}</p>
                <h2 className="title">{t('secJ_title')}</h2>
                <p className="desc">
                    {t.rich('secJ_desc', {
                        w: (text: string) => <span className="white">{text}</span>,
                    })}
                </p>
            </div>
            <div className="boxs">
                <div className="box-1 box">
                    <div className="box-info">
                        <p className="box-title">{t('secJ_box1_title')}</p>
                        <p className="box-desc">{t('secJ_box1_desc')}</p>
                    </div>
                    <div className="scroll-box">
                        <div className="box-img">
                            <EFPicture src="/responsive/picture/smart-home-panel-2/launch/10_1.png" alt={t('secJ_box1_title')} />
                        </div>
                    </div>
                </div>
                <div className="bot-box">
                    <div className="box-2 box">
                        <div className="box-info">
                            <div className="info-top">
                                <p className="box-title">{t('secJ_box2_title')}</p>
                                <p className="box-desc">{t('secJ_box2_desc')}</p>
                                {['us', 'ca'].includes(locale) && (
                                    <Link className="box-link" href={`https://${locale}.ecoflow.com/products/powerinsight-home-energy-manager`} target="_blank">
                                        <span className="link-text">{t('common_learn_more')}</span>
                                        <svg className="link-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path
                                                d="M6.25621 2.35895L11.5895 7.69228L6.2562 13.0256"
                                                stroke="#3F68E0"
                                                strokeWidth="1.4"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    </Link>
                                )}
                            </div>
                            <div className="info-bot">
                                <p className="box-text">{t('secJ_box2_text1')}</p>
                                <p className="box-text">{t('secJ_box2_text2')}</p>
                                <p className="box-text">{t('secJ_box2_text3')}</p>
                                <p className="box-text">{t('secJ_box2_text4')}</p>
                            </div>
                        </div>
                        <div className="box-img">
                            <EFPicture src="/responsive/picture/smart-home-panel-2/launch/10_2.png" alt={t('secJ_box2_title')} />
                        </div>
                    </div>
                    <div className="box-3 box">
                        <div className="box-info">
                            <p className="box-title">{t('secJ_box3_title')}</p>
                            <p className="box-desc">{t('secJ_box3_desc')}</p>
                            {['us', 'ca'].includes(locale) && (
                                <Link className="box-link" href="https://portal.ecoflow.com/user/us/en/login" target="_blank">
                                    <span className="link-text">{t('common_learn_more')}</span>
                                    <svg className="link-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path
                                            d="M6.25621 2.35895L11.5895 7.69228L6.2562 13.0256"
                                            stroke="#3F68E0"
                                            strokeWidth="1.4"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </Link>
                            )}
                        </div>
                        <div className="box-img">
                            <EFPicture src="/responsive/picture/smart-home-panel-2/launch/10_3.png" alt={t('secJ_box3_title')} />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
